import { Fade } from "@mui/material"
import { useParams } from "@tanstack/react-router"
import type { ReactElement } from "react"
import { useState } from "react"

import { InstructionsContent } from "./components/InstructionsContent"
import { InstructionsHeader } from "./components/InstructionsHeader"
import { InstructionsLoading } from "./components/InstructionsLoading"

import { SectionContainer } from "@/components/SectionContainer/SectionContainer"
import AddInstructionDialog from "@/screens/Products/components/Product/Instructions/components/AddInstruction/AddInstructionDialog"
import useGetProductInstructions from "@/screens/Products/components/Product/Instructions/hooks/useGetProductInstructions"

export const InstructionsContainer = (): ReactElement => {
  const { productId } = useParams({ strict: false })
  const [openAddInstruction, setOpenAddInstruction] = useState<boolean>(false)

  // Instructions state and operations
  const { productInstructions, isLoading, refetchInstructionsList } = useGetProductInstructions({
    productId: Number(productId),
  })

  const associatedInstructionIds = productInstructions?.map((i) => i.instructionId) || []

  if (isLoading) {
    return <InstructionsLoading />
  }

  return (
    <SectionContainer className='rounded-md border border-solid border-gray-400 p-6'>
      <Fade in>
        <div className='flex flex-col gap-6'>
          <InstructionsHeader
            onAddClick={() => setOpenAddInstruction(true)}
            hasInstructions={!!productInstructions.length}
          />
          <InstructionsContent
            instructions={productInstructions}
            onAddInstruction={() => setOpenAddInstruction(true)}
            refetchInstructionsList={refetchInstructionsList}
            productId={Number(productId)}
          />
        </div>
      </Fade>
      {openAddInstruction && (
        <AddInstructionDialog
          productId={productId}
          onClose={() => {
            setOpenAddInstruction(false)
          }}
          onSuccess={() => {
            refetchInstructionsList()
            setOpenAddInstruction(false)
          }}
          associatedInstructionIds={associatedInstructionIds}
        />
      )}
    </SectionContainer>
  )
}
